import { render, staticRenderFns } from "./vehicle-favorite-action.vue?vue&type=template&id=5440551f&"
import script from "./vehicle-favorite-action.vue?vue&type=script&lang=js&"
export * from "./vehicle-favorite-action.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-favorite-action.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports